import React, { CSSProperties, PureComponent } from 'react';
import Utils from '../../common/util/Utils';

export type FlexDirection = 'horizontal' | 'vertical';

interface FlexProps extends Omit<React.HTMLAttributes<HTMLDivElement>, 'direction' | 'size'> {
    direction?: FlexDirection;
    size?: string | 'auto'; // flex basis
    shrink?: boolean;
    grow?: boolean;
}

export class Flex extends PureComponent<FlexProps> {
    isAuto = () => {
        return !this.props.size || this.props.size === 'auto';
    };

    getShrinkValue = () => {
        if (Utils.isExists(this.props.shrink)) return this.props.shrink ? '1' : '0';

        return this.isAuto() ? '1' : '0';
    };

    getGrowValue = () => {
        if (Utils.isExists(this.props.grow)) return this.props.grow ? '1' : '0';

        return this.isAuto() ? '1' : '0';
    };

    getBasisValue = () => {
        return this.isAuto() ? 'auto' : this.props.size;
    };

    render() {
        const { direction, style, shrink, grow, size, ...otherProps } = this.props;
        const extraStyle: CSSProperties = Object.assign(
            {},
            {
                display: 'flex',
                flexDirection: direction === 'vertical' ? 'column' : 'row',
                flex: this.getGrowValue() + ' ' + this.getShrinkValue() + ' ' + this.getBasisValue(),
            },
            style,
        );

        return <div className={this.props.className} style={extraStyle} {...otherProps} />;
    }
}
